export const environment = {
  production: true,
  isLocal: false,
};
